class SizeGuideDrawer extends HTMLElement {

  constructor() {
    super()

    this.sizeGuideButton = null
    this.sizeGuideCloseButton = null
    this.sizeGuideCotainer = null,
    this.productInfoContainer = null,

    this.boundOpenDrawerHandler = this.openDrawerHandler.bind(this)
    this.boundCloseDrawerHandler = this.closeDrawerHandler.bind(this)
    this.boundCloseGlobalHandler = this.closeGloblaHandler.bind(this)
    this.boundRenderVariantPickerFinishedHandler = this.renderVariantPickerFinishedHandler.bind(this)
  }

  initEventListeners() {
    this.sizeGuideButton = this.querySelector('.js-size-guide-button')
    this.sizeGuideCloseButton = this.querySelector('.js-button--close-size-guide')
    this.sizeGuideCotainer = this.querySelector('.size__guide')
    this.productInfoContainer = this.querySelector('.product__info')

    if (this.sizeGuideButton) {
      this.sizeGuideButton.addEventListener('click', this.boundOpenDrawerHandler)
    }
    if (this.sizeGuideCloseButton) {
      this.sizeGuideCloseButton.addEventListener('click', this.boundCloseGlobalHandler)
    }
    document.addEventListener('nova:product:render-variant-picker-finished', this.boundRenderVariantPickerFinishedHandler)

    if (this.sizeGuideCotainer) {
      this.setupTableHoverEventListener()
    }
  }

  destroyEventListeners() {
    if (this.sizeGuideButton) {
      this.sizeGuideButton?.removeEventListener('click', this.boundOpenDrawerHandler)
    }

    if (this.sizeGuideCloseButton) {
      this.sizeGuideCloseButton?.removeEventListener('click', this.boundCloseGlobalHandler)
    }

    document.removeEventListener('nova:product:render-variant-picker-finished', this.boundRenderVariantPickerFinishedHandler)

    if (this.sizeGuideCotainer) {
      this.sizeGuideCotainer.querySelectorAll('table').forEach((table) => {
        table.querySelectorAll('td').forEach((cell, index) => {
          if (cell.boundTdMouseEnterHandler) {
            cell?.removeEventListener('mouseenter', cell.boundTdMouseEnterHandler)
            delete cell.boundTdMouseEnterHandler
          }
          if (cell.boundTdMouseLeaveHandler) {
            cell.removeEventListener('mouseleave', cell.boundTdMouseLeaveHandler)
            delete cell.boundTdMouseLeaveHandler
          }
        })
      })
    }

    this.sizeGuideButton = null
    this.sizeGuideCloseButton = null
    this.sizeGuideCotainer = null
    this.productInfoContainer = null
  }

  connectedCallback() {
    this.initEventListeners()
  }

  disconnectedCallback() {
    this.destroyEventListeners()
  }

  reInit() {
    this.destroyEventListeners()
    this.initEventListeners()
  }

  setupTableHoverEventListener() {
    this.sizeGuideCotainer.querySelectorAll('table').forEach((table) => {
      var headerRow = table.querySelector('thead tr')

      table.querySelectorAll('td').forEach((cell, index) => {
        cell.boundTdMouseEnterHandler = (event) => {
          event.stopPropagation()
          this.createTdMouseEnterHandler(cell, headerRow)(event)
        }
        cell.boundTdMouseLeaveHandler = ( event ) => {
          event.stopPropagation()
          this.createTdMouseLeaveHandler(cell, headerRow)(event)
        }
        cell.addEventListener('mouseenter', cell.boundTdMouseEnterHandler)
        cell.addEventListener('mouseleave', cell.boundTdMouseLeaveHandler)
      })
    })
  }

  createTdMouseEnterHandler(cell, headerRow) {
    return (event) => this.tdMouseEnterHandler(cell, headerRow, event)
  }

  createTdMouseLeaveHandler(cell, headerRow) {
    return (event) => this.tdMouseLeaveHandler(cell, headerRow, event)
  }


  tdMouseLeave(trs, hoverIndex) {
    for (var i = 0; i < trs.length; i++) {
      if (i <= hoverIndex)
        trs[i].classList.remove('highlight-row')
    }
  }

  getColumnHeaderByCellIndex(headRow, tdIndex) {
    let colPosition = 0;
    const headers = headRow.querySelectorAll('th');
    for (let i = 0; i < headers.length; i++) {
        const th = headers[i];
        const colspan = parseInt(th.getAttribute('colspan')) || 1;
        if (tdIndex < colPosition + colspan) {
            return th;
        }
        colPosition += colspan;
    }
    return null;
  }

  tdMouseLeaveHandler(cell, headerRow, event) {
    const tdParentElement = cell.parentElement
    const hoverdTdIndex = Array.from(tdParentElement.children).indexOf(event.target)
    const tdParentElementArray = Array.from(tdParentElement.children)
    const trParentElementArray = Array.from(tdParentElement.parentElement.children)
    const trIndex = trParentElementArray.indexOf(tdParentElement)
    const th = this.getColumnHeaderByCellIndex(headerRow, hoverdTdIndex);

    this.tdMouseLeave(tdParentElementArray, hoverdTdIndex)
    th.classList.remove('highlight-row')
    for (var i = 0; i < trParentElementArray.length; i++) {
      if (i <= trIndex)
        this.tdMouseLeave(Array.from(trParentElementArray[i].children), hoverdTdIndex)
    }
  }

  tdMouseEnterHandler(cell, headerRow, event) {
    const tdParentElement = cell.parentElement
    const hoverdTdIndex = Array.from(tdParentElement.children).indexOf(event.target)
    const tdParentElementArray = Array.from(tdParentElement.children)
    const trParentElementArray = Array.from(tdParentElement.parentElement.children)
    const trIndex = trParentElementArray.indexOf(tdParentElement)
    const th = this.getColumnHeaderByCellIndex(headerRow, hoverdTdIndex);
    th.classList.add('highlight-row')

    for (var i = 0; i < tdParentElementArray.length; i++) {
      if (i <= hoverdTdIndex)
        tdParentElementArray[i].classList.add('highlight-row')
    }

    for (var i = 0; i < trParentElementArray.length; i++) {
      if (i <= trIndex)
        Array.from(trParentElementArray[i].children)[hoverdTdIndex].classList.add('highlight-row')
    }
  }

  renderVariantPickerFinishedHandler() {
    this.resetOpenDrawerHandler()
  }

  resetOpenDrawerHandler() {
    this.sizeGuideButton = this.querySelector('.size-guide-button')
    this.sizeGuideButton?.removeEventListener('click', this.boundOpenDrawerHandler)
    this.sizeGuideButton?.addEventListener('click', this.boundOpenDrawerHandler)
  }

  openDrawerHandler() {
    if (!this.sizeGuideCotainer || !this.productInfoContainer)
      return

    this.sizeGuideCotainer.classList.add('open')
    this.sizeGuideCotainer.classList.remove('hidden')

    this.productInfoContainer.classList.add('product-size-guide--show')
  }

  closeDrawerHandler() {
    if (!this.sizeGuideCotainer || !this.productInfoContainer)
      return

    this.sizeGuideCotainer.classList.remove('open')
    this.sizeGuideCotainer.classList.add('hidden')

    this.productInfoContainer.classList.remove('product-size-guide--show')
  }


  closeGloblaHandler(e) {
    if (!this.sizeGuideCotainer || !this.sizeGuideCotainer.classList.contains('open'))
      return

    this.boundCloseDrawerHandler()
  }

}

customElements.define('size-guide-drawer', SizeGuideDrawer)
